import { Box, Button, IconButton, Menu, MenuItem, Switch } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import SearchBar from '../../components/SearchBar';
import TableComponent from '../../components/TableComponent';
import { showError, showToast } from '../../constants/toasts';
import { errorToast } from '../../helpers';
import MainContainer from '../../layout/MainContainer';
import { ConfirmationModal } from '../../Modals/confirmationModal';
import {
  useLazyDeletePackageQuery,
  useLazyGetPackageQuery,
  useUpdatePackageMutation,
} from '../../service/packages';
import { CommonBody, Packages } from '../../types/General';
import { generateEncryptedKeyBody } from '../../utils/crypto';
import { SUBSCRIPTION_PLAN } from '../../utils/enums';
import { isValidInput } from '../../utils/validations';

const ManagePackages = () => {
  const navigate = useNavigate();
  const [page, setPage] = useState<number>(1);
  const [loading, setLoading] = useState(false);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>('');
  const [searchTerm, setSearchTerm] = useState('');
  const [openDetail, setOpenDetail] = useState(false);
  const [getPackage] = useLazyGetPackageQuery();
  const [hidden, setHidden] = useState<string[]>([]);
  const [openDelete, setOpenDelete] = useState(false);
  const [rows, setRows] = useState<Packages[]>([]);
  const [selectedId, setSelectedId] = useState<string>('');
  const [deletePakage] = useLazyDeletePackageQuery();
  const [updatedPackage] = useUpdatePackageMutation();
  const [count, setCount] = useState<number>();
  const [anchorEl1, setAnchorEl1] = React.useState<null | HTMLElement>(null);
  const handlePageChange = (event: any, newPage: number) => {
    setPage(newPage + 1);
  };

  const handleClose = () => {
    setOpenDetail(false);
  };

  const handleClick1 = (event: React.MouseEvent<HTMLButtonElement>, rowId: string) => {
    setAnchorEl1(event.currentTarget);
    setSelectedId(rowId);
  };

  const open1 = Boolean(anchorEl1);

  // const handleClick1 = (event: React.MouseEvent<HTMLButtonElement>) => {
  //   setAnchorEl1(event.currentTarget);
  // };
  const handleClose1 = () => {
    setAnchorEl1(null);
  };

  const handleDelete = async () => {
    setLoading(true);
    try {
      const response = await deletePakage({
        id: selectedId,
      }).unwrap();
      setLoading(false);

      if (response?.statusCode === 200) {
        showToast('Deleted successfully');
        getPackagesList();
      }
    } catch (error: any) {
      showError(error?.data?.message || '');
      setLoading(false);
    }
  };

  const updateStatus = async (id: string, flag: boolean) => {
    try {
      const body = {
        isBlocked: flag,
      };
      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const res = await updatedPackage({ body: encryptedBody, id }).unwrap();
      if (res?.statusCode === 200) {
        showToast('Package status change successfully.');
        setRows((prev) => prev.map((pkg) => (pkg._id === id ? { ...pkg, isBlocked: flag } : pkg)));
      }
    } catch (error: any) {
      console.error(error);
      errorToast(error?.data?.message);
    }
  };

  const label = { inputProps: { 'aria-label': 'Switch demo' } };

  // const rows = [
  //   {
  //     id: 1,
  //     name: "Basic",
  //     listings: "1",
  //     price: "$1",
  //   },
  //   {
  //     id: 2,
  //     name: "Elite",
  //     listings: "10",
  //     price: "$10",
  //   },
  // ];

  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 1,
      minWidth: 300,
      field: 'title',
      headerName: 'Name',
      editable: false,
      sortable: false,
    },
    {
      flex: 1,
      minWidth: 200,
      field: 'noOfListings',
      headerName: 'Listings Allowed',
      editable: false,
      sortable: false,
    },
    {
      flex: 1,
      minWidth: 200,
      field: 'validity',
      headerName: 'Validity',
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{SUBSCRIPTION_PLAN[row?.validity] || '-'}</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 100,
      field: 'price',
      headerName: 'Price',
      editable: false,
      sortable: false,
    },
    {
      flex: 0.1,
      minWidth: 150,
      field: 'status',
      filterable: false,
      sortable: false,
      headerName: 'Block/Unblock',
      renderCell: ({ row }) => {
        return (
          <Switch
            {...label}
            size="small"
            defaultChecked
            checked={!row?.isBlocked}
            onChange={() => updateStatus(String(row?._id), !row.isBlocked)}
          />
        );
      },
    },
    {
      flex: 0.1,
      minWidth: 80,
      field: 'action',
      headerName: 'Action',
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="table_actions">
            <Box>
              <IconButton
                aria-controls={open1 ? 'basic-menu1' : undefined}
                aria-haspopup="true"
                aria-expanded={open1 ? 'true' : undefined}
                onClick={(event) => handleClick1(event, row?._id as string)}
              >
                <img src="/static/images/more_icon.svg" alt="" />
              </IconButton>
              <Menu
                className="setting_menu"
                id="basic-menu1"
                anchorEl={anchorEl1}
                open={open1}
                onClose={handleClose1}
                MenuListProps={{
                  'aria-labelledby': 'basic-button1',
                }}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: 'visible',
                    boxShadow: '0px 4px 20px 0px rgba(0, 0, 0, 0.05)',
                    borderRadius: '8px',
                    mt: 1,
                  },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
              >
                <MenuItem
                  onClick={() => {
                    navigate(`edit/${selectedId}`);
                    handleClose1();
                  }}
                >
                  Edit
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    setAnchorEl1(null);
                    setOpenDelete(true);
                  }}
                >
                  Delete
                </MenuItem>
              </Menu>
            </Box>
          </div>
        );
      },
    },
  ];

  const getPackagesList = async () => {
    try {
      setLoading(true);
      const response = await getPackage({
        page,
        limit: 10,
        search: debouncedSearchTerm,
      }).unwrap();

      if (response.statusCode === 200) {
        if (response?.data?.list) {
          setRows(response?.data?.list);
          setCount(response?.data?.totalCount);
        } else {
          setRows([]);
          setCount(0);
        }
        // console.log(response?.data)
      }
    } catch (error: any) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getPackagesList();
  }, [debouncedSearchTerm, page]);

  return (
    <MainContainer>
      <div className="main_title">
        <h1> Packages</h1>
        <p>
          <span onClick={() => navigate('/dashboard')}>Dashboard</span> - Packages
        </p>
      </div>

      <div className="cards">
        <Box className="custom_tabs" sx={{ width: '100%' }}>
          <div className="table_header">
            <div className="left_s">
              <Box className="search_box">
                <SearchBar
                  searchTerm={searchTerm}
                  placeholder="Search Package.."
                  setDebouncedSearchTerm={setDebouncedSearchTerm}
                  value={searchTerm}
                  onCross={() => setSearchTerm('')}
                  onChange={(val: any) => {
                    if (isValidInput(val.target.value)) {
                      setSearchTerm(val.target.value);
                    }
                  }}
                />
              </Box>
            </div>
            <div className="right_s">
              <Box>
                <Button className="btn btn_orange" onClick={() => navigate('add')}>
                  Add Package
                </Button>
              </Box>
            </div>
          </div>

          <div className="sorting_table">
            <TableComponent
              columns={columns?.filter((item: any) => !hidden.includes(item.field))}
              rows={rows}
              count={count}
              page={page}
              loading={loading}
              onPageChange={handlePageChange}
            />
          </div>
        </Box>
        {/* <BlogDetailModal
          open={openDetail}
          setOpen={setOpenDetail}
          onClose={handleClose}
        /> */}
        <ConfirmationModal
          text="Are you sure to delete this package?"
          openModal={openDelete}
          setOpenModal={setOpenDelete}
          handleSubmit={handleDelete}
        />
      </div>
    </MainContainer>
  );
};

export default ManagePackages;
